import { useBadgeData } from './useBadgeCounts';

export const STEP_EDIT_REQUESTS_QUERY_KEY = ['pending-step-edit-requests'];

/** Pending step-edit request count for the sidebar badge (shared /badge-counts poll). */
export function useStepEditCount() {
  return useBadgeData().data?.step_edits ?? 0;
}
